// ui.module.ts
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { IconComponent } from './icon/icon.component';
import { CellButtonComponent } from './cell-button/cell-button.component';
import { PillComponent } from './pill/pill.component';
import { ButtonComponent } from './button/button.component';
import { NavButtonComponent } from './nav-button/nav-button.component';
import { SectionLabelComponent } from './section-label/section-label.component';
import { CardButtonComponent } from './card-button/card-button.component';
import { CurrencyButtonComponent } from './currency-button/currency-button.component';
import { CurrencyIconComponent } from './currency-icon/currency-icon.component';
import { GameIconComponent } from './game-icon/game-icon.component';
import { GameTitleComponent } from './game-title/game-title.component';
import { PillTabButtonComponent } from './pill-tab-button/pill-tab-button.component';
import { TabBarComponent } from './tab-bar/tab-bar.component';
import { TabButtonComponent } from './tab-button/tab-button.component';
import { DropDownButtonComponent } from './drop-down-button/drop-down-button.component';
import { PrizePillComponent } from './prize-pill/prize-pill.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { TranslocoModule } from '@jsverse/transloco';
import { WagerCardComponent } from './wager-card/wager-card.component';
import { LeaderboardListCellComponent } from './leaderboard-list-cell/leaderboard-list-cell.component';
import { WagerListComponent } from './wager-list/wager-list.component';
import { WaitingForPaymentDrawerComponent } from './drawers/waiting-for-payment-drawer/waiting-for-payment-drawer.component';
import { CheckPaymentsDrawerComponent } from './drawers/check-payments-drawer/check-payments-drawer.component';
import { PaymentDrawerComponent } from './drawers/payment-drawer/payment-drawer.component';
import { LightningWebPayTemplateComponent } from './templates/lightning-web-pay-template/lightning-web-pay-template.component';
import { LightningNativePayTemplateComponent } from './templates/lightning-native-pay-template/lightning-native-pay-template.component';
import { LightningOperatorPayTemplateComponent } from './templates/lightning-operator-pay-template/lightning-operator-pay-template.component';
import { OperatorPayTemplateComponent } from './templates/operator-pay-template/operator-pay-template.component';
import { PipeModule } from '../core/pipes/pipes.module';
import { BountyPillComponent } from './bounty-pill/bounty-pill.component';
import { ContinueMatchCellComponent } from './continue-match-cell/continue-match-cell.component';
import { TournamentRulesComponent } from './tournament-rules/tournament-rules.component';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  imports: [IonicModule, CommonModule, PipeModule, TranslocoModule, QRCodeModule],
  declarations: [
    LoadingSpinnerComponent,
    IconComponent,
    CellButtonComponent,
    PillComponent,
    ButtonComponent,
    NavButtonComponent,
    SectionLabelComponent,
    CardButtonComponent,
    CurrencyButtonComponent,
    CurrencyIconComponent,
    GameIconComponent,
    GameTitleComponent,
    PillTabButtonComponent,
    TabBarComponent,
    TabButtonComponent,
    DropDownButtonComponent,
    PrizePillComponent,
    StatusBadgeComponent,
    WagerCardComponent,
    LeaderboardListCellComponent,
    WagerListComponent,
    WaitingForPaymentDrawerComponent,
    CheckPaymentsDrawerComponent,
    PaymentDrawerComponent,
    LightningWebPayTemplateComponent,
    LightningNativePayTemplateComponent,
    LightningOperatorPayTemplateComponent,
    OperatorPayTemplateComponent,
    BountyPillComponent,
    ContinueMatchCellComponent,
    TournamentRulesComponent,
  ],
  exports: [
    LoadingSpinnerComponent,
    IconComponent,
    CellButtonComponent,
    PillComponent,
    ButtonComponent,
    NavButtonComponent,
    SectionLabelComponent,
    CardButtonComponent,
    CurrencyButtonComponent,
    CurrencyIconComponent,
    GameIconComponent,
    GameTitleComponent,
    PillTabButtonComponent,
    TabBarComponent,
    DropDownButtonComponent,
    PrizePillComponent,
    StatusBadgeComponent,
    WagerCardComponent,
    LeaderboardListCellComponent,
    WagerListComponent,
    WaitingForPaymentDrawerComponent,
    CheckPaymentsDrawerComponent,
    PaymentDrawerComponent,
    LightningWebPayTemplateComponent,
    LightningNativePayTemplateComponent,
    LightningOperatorPayTemplateComponent,
    OperatorPayTemplateComponent,
    BountyPillComponent,
    ContinueMatchCellComponent,
    TournamentRulesComponent,
  ],
})
export class UIModule {}
